import type { GridSortDirection } from '@mui/x-data-grid-premium'

export const SORTING_ORDER = ['desc', 'asc'] as GridSortDirection[]
